import { createSelector } from '@ngrx/store';

export const getDiscountGroupsState = createSelector(
    (state: any) => state.discountGroups,
    (state: any) => state.get('list')
);

export const getCreateDiscountGroupState = createSelector(
    (state: any) => state.discountGroups,
    (state: any) => state.get('createDiscountGroup')
);

export const getUpdateDiscountGroupState = createSelector(
    (state: any) => state.discountGroups,
    (state: any) => state.get('updateDiscountGroup')
);
 